import React from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import helpData from "./helpData";

export default function Help() {
  const generateHelpList = () => {
    return helpData.map((help) => {
      return (
        <div className="pb-3">
          <div>
            <div className="d-flex align-items-center">
              <span className="pl-2">
                <i className="fas fa-graduation-cap"></i>
              </span>
              <span>{help.header}</span>
            </div>
            <div>
              <hr />
            </div>
          </div>
          <div className="row">
            {help.links.map((link) => {
              return (
                <div className="col-12 col-lg-6 py-2">
                  <span>
                    <span className="px-2">
                      <i className="fas fa-circle"></i>
                    </span>
                    <span>
                      <Link className="text-success" to={link.href}>
                        {link.title}
                      </Link>
                    </span>
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      );
    });
  };

  return (
    <>
      <Sidebar openItem="tickets" activeItem="help" />

      <div className="content-wrapper">
        <TitleBar title="راهنمای هایلایت" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">{generateHelpList()}</div>
          </div>
        </section>
      </div>
    </>
  );
}
